var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('welcome-banner'),_c('Introduction'),_c('phone-container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }